import React, { type ReactNode, useCallback, memo, useRef } from 'react';
import noop from 'lodash/noop';
import Button from '@atlaskit/button';
import EditorFeedbackIcon from '@atlaskit/icon/core/migration/feedback--editor-feedback';
import { Text } from '@atlaskit/primitives';
import { useFeedbackCollector } from '@atlassian/jira-business-feedback-collector/src/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { QuickstartNudge } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/quickstart-nudge/main.tsx';
import { FeedbackNudgeAsync } from '@atlassian/jira-software-onboarding-nudges--next/src/ui/jwm-feedback/async.tsx';
import messages from './messages.tsx';

const FEEDBACK_GROUP_ID = 'jbus-feedback';

const FeedbackButton = () => {
	const { formatMessage } = useIntl();
	const openFeedbackModal = useFeedbackCollector();
	const buttonRef = useRef<HTMLButtonElement>(null);
	const renderNudgeWrapper = useCallback(
		(children: ReactNode) => <FeedbackNudgeAsync>{children}</FeedbackNudgeAsync>,
		[],
	);

	const onClick = useCallback(() => {
		openFeedbackModal(FEEDBACK_GROUP_ID, noop, buttonRef);
	}, [openFeedbackModal]);

	return (
		<QuickstartNudge renderWrapper={renderNudgeWrapper}>
			<Button
				ref={buttonRef}
				iconBefore={<EditorFeedbackIcon label="" LEGACY_size="small" />}
				appearance="subtle-link"
				onClick={onClick}
			>
				<Text as="span" size="UNSAFE_small" weight="medium" color="color.text.subtle">
					{formatMessage(messages.feedback)}
				</Text>
			</Button>
		</QuickstartNudge>
	);
};

export default memo(FeedbackButton);
